import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { IndustryTypeBadgeProps } from "./IndustryTypeBadge.types"

const icon = faIcon({ name: "swatchbook", style: "regular" })

export default function IndustryTypeBadge(props: IndustryTypeBadgeProps) {
    const { industryType, size = "md" } = props

    // Only shown when the object has an industry type.
    if (!industryType) {
        return null
    }

    return (
        <Badge size={size} variant="icon" icon={icon}>
            {industryType}
        </Badge>
    )
}
